import nl from './nl-NL';
import en from './en-US';

export default {
	nl,
	en,
};
